import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { Table } from 'primeng/table';
import { ExportService } from 'src/app/services/export.service';
import { GlobalConstants } from 'src/app/services/global-constants';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
})
export class TableComponent {
  @Output() actionCall = new EventEmitter<any>();

  @Input() data: any;
  @Input() unit: any;
  translator: TranslatorPipe = new TranslatorPipe()

  constructor(
    private exportService: ExportService,
    private permissionService: PermissionHandlerService
  ) { }

  @ViewChild('dt')
  dt!: Table;

  cols: any[] = [];
  exportColumns: { title: any; dataKey: any }[] = [];
  cleanedData: Array<any> = [];
  imgUrl: string = GlobalConstants.staticFilesURL;

  staticURL = GlobalConstants.staticFilesURL;

  totalRecords: number = 0;
  pageSize: number = 10;
  currentPage: number = 1;


  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false;
    }
  }

  checkCombinePermission() {
    return (
      this.permissionService.hasPermission(this.unit, 'u') ||
      this.permissionService.hasPermission(this.unit, 'd')
    );
  }

  checkUpdatePermission() {
    return this.permissionService.hasPermission(this.unit, 'u');
  }

  checkDeletePermission() {
    return this.permissionService.hasPermission(this.unit, 'd');
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  sizes: any[] = [
    { name: '-', class: 'p-datatable-sm' },
    { name: '=', class: '' },
    { name: '+', class: 'p-datatable-lg' },
  ];
  selectedSize: any = this.sizes[1].class;

  keys: any = [];
  filterKeys: any = [];
  globalFilter: string = '';
  filteredData: any[] = [];

  ngOnInit() {
    let keys = Object.keys(this.data[0]);
    this.keys = keys;
    this.totalRecords = this.data.length;
    console.log("===>total records", this.totalRecords);
    this.cleanedData = this.exportService.cleanData(this.data);
    this.cols = this.exportService.extractColumns(this.cleanedData[0]);
    this.filterKeys = this.keys.map((e: any) => e + '.n');
    this.applyGlobalFilter();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data']) {
      // Handle the changes to myInputValue
      this.data = changes['data'].currentValue;
      this.applyGlobalFilter();
      this.totalRecords = this.data.length;
      let keys = Object.keys(this.data[0]);
      if (!this.checkCombinePermission()) {
        keys = keys.filter((e: any) => e != 'Action');
      }
      this.keys = keys;
      this.cleanedData = this.exportService.cleanData(this.data);
      this.cols = this.exportService.extractColumns(this.cleanedData[0]);
      this.filterKeys = this.keys.map((e: any) => e + '.n');
    }
  }

  actionClick(action: String, ID: String) {
    console.log('actionClick', action, ID);
    this.actionCall.emit({ action: action, id: ID });
  }

  selectedSizeChange($event: any) {
    this.selectedSize = $event.value;
  }

  clear(table: Table) {
    table.clear();
  }

  // applyFilterGlobal($event: any) {
  //   console.log("filter",$event.target.value);
  //   this.data.filterGlobal($event.target.value, 'contains');
  // }

  applyGlobalFilter() {
    const searchTerm = this.globalFilter.toLowerCase();

    this.filteredData = this.data.filter((item: any) => this.filterItem(item, searchTerm));

    console.log("this.filteredData ===>", this.filteredData, this.data, searchTerm);

    this.totalRecords = this.filteredData.length;
  }

  filterItem(item: any, searchTerm: string): boolean {
    const doesItemContainTerm = (value: any): boolean => {
      if (typeof value === 'string') {
        return value.toLowerCase().includes(searchTerm);
      } else if (typeof value === 'object' && value !== null) {
        return Object.values(value).some(doesItemContainTerm);
      }
      return false;
    };

    return Object.values(item).some(doesItemContainTerm);
  }

  public exportExcel() {
    this.exportService.exportExcel(this.data);
  }

  public exportPdf() {
    this.exportService.exportToPdf(this.data);
  }

  public exportCSV() {
    this.exportService.exportToCsv(this.cleanedData);
  }

  onPageChange(event: any) {
    this.currentPage = event.page + 1;
  }

  get visibleData(): any[] {
    const startIndex = (this.currentPage - 1) * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    return this.filteredData.slice(startIndex, endIndex);
  }

  handleUpdateDeletePermission(n: string) {
    console.log(n,n == this.translate('Deactivated Accounts'),this.checkDeletePermission());
    if (n == 'Delete') {
      return this.checkDeletePermission()
    } else if (n == 'Update') {
      return this.checkUpdatePermission()
    } else if (n == 'Activate' || n == 'Undo') {
      return this.checkUpdatePermission()
    } else if (n == this.translate('Deactivated Accounts')) {
      return this.checkDeletePermission();
    }
    console.log(n);
    return false;
  }
}
